import React from "react";
import { Navigate } from "react-router-dom";

import useAuth from "../../hooks/useAuth";
import useSidebarMenu from "../../hooks/useSidebarMenu";
import queryClient from "../../utils/queryClient";
import { getHomeForRole } from "../../utils/links";
import logger from "../../utils/logger";

/**
 * Sends the signed-in user to their role's home page (ROLE_HOME in
 * utils/links.js), or to the first sidebar page when that home is not in
 * the role's menu.
 */
const Home = () => {
  const { role } = useAuth();
  const { menu, isLoading } = useSidebarMenu();

  if (isLoading) {
    return null;
  }

  const home = getHomeForRole(role, menu);

  if (!home) {
    logger.warn(`[Home] No TalentEngine role in session (stored: ${role || "none"}) — returning to login.`);
    localStorage.clear();
    queryClient.clear();
    return <Navigate to="/login" />;
  }

  logger.debug(`[Home] Role "${role}" → ${home}.`);
  return <Navigate to={home} replace />;
};

export default Home;
